<template>
  <div :class="$style.calendar">
    <div :class="$style.nav">
      <b-button @click="goPrevMonth">&laquo;</b-button>
      <div :class="$style.month">{{ current.month }}月</div>
      <b-button @click="goNextMonth">&raquo;</b-button>
    </div>

    <div :class="$style.day">
      <tr v-for="week in calendarData" :key="week.id">
        <td
          v-for="day in week"
          :key="day"
          :class="{ [$style.active]: current.date == day }"
          @click="
            clickDate(day);
            scroll();
          "
        >
          <span :class="$style.num">{{ day }}</span>
          <span :class="$style.count">{{ getLength(day) }}</span>
        </td>
      </tr>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";


export default Vue.extend({
  name: "Calendar",
  data() {
    return {
      current: {
        month: 1,
        date: 1,
      },
    };
  },
  props: {
    items: {
      type: Array,
    },
  },
  mounted() {
    this.current.year = moment().year()
    this.current.month = moment().month() + 1;
    this.current.date = moment().date();
    this.$emit("child_event", this.current);
  },
  computed: {
    calendarData() {
      // 指定した月が何日まであるか算出する
      const numOfMonth = moment(this.current.year+"-"+this.current.month,"YYYY-MM").daysInMonth();

      // 指定した月の1〜最終日までの配列
      const daysOfMonth = [...Array(numOfMonth).keys()].map((i) => ++i);

      // 週ごとの二次元配列を生成
      const numOfWeeks = Math.ceil(numOfMonth / 7)
      const daysOfLastweek = numOfMonth-(numOfWeeks-1)*7
      
      const data = [...Array(numOfWeeks)].map((empty, weekIndex) =>
            {
              const i = 7 * weekIndex
              if (weekIndex!=(numOfWeeks-1)){
                return [...Array(7)].map((empty,dayIndex)=>daysOfMonth[i+dayIndex])
              }else{
                return [...Array(daysOfLastweek)].map((empty,dayIndex)=>daysOfMonth[i+dayIndex])
              }
            });

      return data;
    },
  },
  methods: {
    goNextMonth() {
      let month = (this.current.month + 1) % 12;
      if (month == 0) {
        month = 12;
      }
      this.current.month = month;
      this.current.date = 1;
      this.$emit("child_event", this.current);
    },
    goPrevMonth() {
      let month = (this.current.month - 1) % 12;
      if (month == 0) {
        month = 12;
      }
      this.current.month = month;
      this.current.date = 1;
      this.$emit("child_event", this.current);
    },
    clickDate(day) {
      this.current.date = day;
      this.$emit("child_event", this.current);
    },
   
    getLength(day) {
      // if (this.items[this.current.month - 1][day] == null && day != null) {
        // return 0;
      // }
      if (day == null) {
        return;
      }
      return this.items.filter(item=>item.date==day&&item.month==this.current.month).length;
    },
    scroll() {
      this.$emit("child_scroll");
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .calendar {
    width: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
      .month {
        font-size: 26px;
        width: 200px;
        text-align: center;
      }
      button {
        width: 40px;
        font-size: 40px;
        padding: 0;
        background: #fff;
        color: #403f3f;
        border: none;
      }
    }
    .day {
      font-size: 18px;
      tr {
        height: 55px;
        display: flex;
        td {
          height: 45px;
          width: 45px;
          display: table-cell;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          &:hover {
            background: rgba(#403f3f, 0.7);
            border-radius: 50%;
            color: #fff;
          }
          .num {
            display: inline-block;
            height: 23px;
          }
          .count {
            display: inline-block;
            font-size: 13px;
            color: #0027c9;
          }
        }
        .active {
          border-radius: 50%;
          border: solid 1px #403f3f;
        }
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .calendar {
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
      .month {
        font-size: 26px;
        width: 200px;
        text-align: center;
      }
      button {
        width: 40px;
        font-size: 40px;
        padding: 0;
        background: #fff;
        color: #403f3f;
        border: none;
      }
    }
    .day {
      font-size: 23px;
      tr {
        height: 65px;
        display: flex;
        td {
          height: 60px;
          width: 60px;
          display: table-cell;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          &:hover {
            background: rgba(#403f3f, 0.7);
            border-radius: 50%;
            color: #fff;
          }
          .num {
            display: inline-block;
            height: 30px;
          }
          .count {
            display: inline-block;
            font-size: 15px;
            color: #0027c9;
          }
        }
        .active {
          border-radius: 50%;
          border: solid 1px #403f3f;
        }
      }
    }
  }
}
</style>
